import { Navigate } from 'react-router';
import { useAuth } from '@/lib/use-auth';
import { ParentDashboard, TutorDashboard } from './home';

export function HomePage() {
  const { user } = useAuth();
  if (!user) return null;

  // Redirect parents with empty lastName to profile completion page
  if (user.role === 'parent' && !user.lastName) {
    return <Navigate to="/profile" replace />;
  }

  if (user.role === 'tutor') {
    return <TutorDashboard />;
  }

  return <ParentDashboard />;
}
